import { LogErrors } from './../../LogErrors'
import { GetCourseProgressSummary as DLGetCourseProgressSummary, GetCourseProgressPanelInstructor as DLGetCourseProgressPanelInstructor, GetGroupZtudiantes as DLGetGroupZtudiantes } from './../../DL/Leader/Progress'


/**
 * Función auxiliar para obtener datos base de sesión de forma segura.
 */
const getSessionBaseData = () => {
    if (!sessionStorage.getItem('userData')) return null
    
    const userData = JSON.parse(sessionStorage.getItem('userData'))
    const token = userData?.token
    const idCenter = userData?.navigation?.center?.id
    const idUserRequest = userData?.user?.idUser ?? userData?.user?.id // Quien hace la petición
    const idUserRol = 3 // Rol estático de Líder
    
    if (!token || !idCenter) return null
    return { token, idCenter, idUserRequest, idUserRol }
}

/**
 * Llama al EndPoint para obtener el avance general (%) de una lista de estudiantes.
 */
const GetCourseProgressSummaryForLeader = async (idInstructor, idGroup, idCourse, userIdsArray) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión expirada o inválida.' }

        const payload = {
            idInstructor: idInstructor,
            idCenter: session.idCenter,
            idCourse: idCourse,
            idGroup: idGroup,
            idUserRol: session.idUserRol,
            userIds: userIdsArray
        }

        return await DLGetCourseProgressSummary(payload, session.token)
    } catch (error) {
        await LogErrors('GetCourseProgressSummaryForLeader - BL Progress', error)
        return { success: false, message: 'Error interno al obtener resumen de progreso.' }
    }
}

/**
 * Llama al EndPoint para obtener el desglose por bloques para exportar a Excel individual.
 */
const GetCourseProgressDetailForLeader = async (idInstructor, idCourse, idZtudiante) => {
    try {
        const session = getSessionBaseData()
        if (!session) return { success: false, message: 'Sesión expirada o inválida.' }

        const payload = {
            idUser: idZtudiante,
            idCenter: session.idCenter,
            idCourse: idCourse,
            IdUserRequest: session.idUserRequest,
            IdUserRol: session.idUserRol,
            IdInstructor: idInstructor
        }

        return await DLGetCourseProgressPanelInstructor(payload, session.token)
    } catch (error) {
        await LogErrors('GetCourseProgressDetailForLeader - BL Progress', error)
        return { success: false, message: 'Error interno al obtener detalle de progreso.' }
    }
}

/**
 * Llama al EndPoint para obtener los Ztudiantes de un grupo para el Líder de Proyecto.
 * 
 * @param {number} idInstructor - ID del instructor seleccionado
 * @param {number} idGroup - ID del grupo seleccionado
 */
const GetGroupZtudiantes = async (idInstructor, idGroup) => {
    try {
        const session = getSessionBaseData() // Usamos el helper que ya tenías en este archivo
        if (!session) return { success: false, message: 'Sesión expirada o inválida.' }

        const payload = {
            idGroup: idGroup,
            idCenter: session.idCenter,
            idUserRol: session.idUserRol, // 3
            idInstructor: idInstructor
        }

        return await DLGetGroupZtudiantes(payload, session.token)
    } catch (error) {
        await LogErrors('GetZtudentsForLeaderProgress - BL Progress', error)
        return { success: false, message: 'Error interno al obtener el listado de Ztudiantes.' }
    }
}

export { GetCourseProgressSummaryForLeader, GetCourseProgressDetailForLeader, GetGroupZtudiantes };